import { format, formatDistanceToNowStrict, differenceInHours, isYesterday, parseISO } from 'date-fns'

export const formatDateDashed = date => {
  const d = new Date(date)
  if (isNaN(d.getTime())) {
    // Check for invalid date
    return 'Invalid Date'
  }
  return `${d.getUTCDate()}-${d.getUTCMonth() + 1}-${d.getUTCFullYear()}`
}
export const formatDateSlash = date => {
  const d = new Date(date)
  return `${d.getDate()}/${d.getMonth() + 1}/${d.getFullYear()}`
}

export const formatDateTime = date => {
  const d = new Date(date)
  let hours = d.getHours()
  let minutes = d.getMinutes().toString().padStart(2, '0')
  const ampm = hours >= 12 ? 'PM' : 'AM'
  // Convert to 12-hour format
  hours = hours % 12
  hours = hours || 12 // the hour '0' should be '12'
  return `${formatDateDashed(d)} ${hours}:${minutes} ${ampm}`
}

export const formatTime = date => {
  const d = new Date(date)
  let hours = d.getHours()
  let minutes = d.getMinutes().toString().padStart(2, '0')
  const ampm = hours >= 12 ? 'PM' : 'AM'

  // Convert to 12-hour format
  hours = hours % 12
  hours = hours || 12 // the hour '0' should be '12'

  return `${hours}:${minutes} ${ampm}`
}

export const formatTimestamp = timestamp => {
  const date = typeof timestamp === 'string' ? parseISO(timestamp) : timestamp
  const now = new Date()
  const hoursAgo = differenceInHours(now, date)

  if (hoursAgo < 1) {
    return formatDistanceToNowStrict(date, { addSuffix: true }) // "45 minutes ago"
  } else if (hoursAgo < 24) {
    return format(date, 'HH:mm') // "14:25"
  } else if (hoursAgo < 48 && isYesterday(date)) {
    return 'Yesterday'
  } else {
    return format(date, 'MMM dd, yyyy') // "May 25, 2025"
  }
}
